import * as React from 'react';
import { CloseIcon } from '../../components/close_icon';

const styles = require('./styles.css');

export interface IProlongationPopupCloseIconProps {
  onClick(): void;
}

export const ProlongationPopupCloseIcon: React.FC<IProlongationPopupCloseIconProps> = ({ onClick }) => (
  <CloseIcon onClick={onClick} className={styles['close']} />
);
